import React from 'react';

export interface SidePanelProps {
  isOpen: boolean;
  onToggle: () => void;
  controlsVisible: boolean;
  contentRef?: React.Ref<HTMLDivElement>;
  /** When false the toggle button is hidden (panel div still renders so the ref is available). */
  hasElement?: boolean;
  /** Tooltip text shown on hover over the toggle button. */
  tooltip?: string;
  children?: React.ReactNode;
}

const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onToggle,
  controlsVisible,
  contentRef,
  hasElement = true,
  tooltip,
  children,
}) => {
  // When panel is open, always visible; when closed, follow controls visibility
  const isVisible = isOpen || controlsVisible;

  return (
    <div
      className={
        `kollab-player-sidepanel-container` +
        (isOpen ? ' kollab-player-sidepanel-container--open' : '') +
        (isVisible && hasElement ? '' : ' kollab-player-sidepanel-container--hidden')
      }
    >
      <button
        className="kollab-player-sidepanel-toggle"
        onClick={onToggle}
        aria-label={tooltip || (isOpen ? 'Hide side panel' : 'Show side panel')}
        data-tooltip={tooltip || undefined}
        type="button"
      >
        {isOpen ? <ChevronRight /> : <ChevronLeft />}
      </button>
      <div ref={contentRef} className="kollab-player-sidepanel">
        {children}
      </div>
    </div>
  );
};
